import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { currency } from 'app/constants/currency.constants';
import { HTTPService, HelperService } from 'app/services';

@Component({
  selector: 'app-tire-shipping-recalculate',
  templateUrl: './tire-shipping-recalculate.component.html',
  styleUrls: ['./tire-shipping-recalculate.component.scss'],
  providers: [DialogService],
})
export class TireShippingRecalculateComponent implements OnInit {
  partsOrderingType: string = '';
  usd: string = currency.USD;
  stores: any[] = [];
  isShippingCostLoading: boolean = false;

  constructor(private dynamicDialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, public helperService: HelperService, private httpService: HTTPService) {}

  ngOnInit() {
    const data = this.dynamicDialogConfig.data;
    this.partsOrderingType = data.partsOrderingType;
    this.setData(data.stores || []);
  }

  async setData(stores: any[]) {
    try {
      this.stores = stores.filter(({ parts }) => parts?.length);
      this.stores = this.stores.map((store) => ({ ...store, previousShippingCost: store.shippingPrice }));

      if (['TireHub', 'TireConnect'].includes(this.partsOrderingType)) {
        this.isShippingCostLoading = true;

        if (this.partsOrderingType === 'TireHub') {
          const warehouses = [];

          this.stores.forEach(({ store, parts }) => {
            warehouses.push({
              warehouseId: store.warehouseId,
              items: parts.map(({ itemId, quantity }) => ({ itemId, quantity })),
            });
          });

          const shippingCosts = await this.httpService.getFreightCharges(warehouses);

          this.stores.forEach((store, index) => {
            store.shippingCost = shippingCosts[index]?.rate;
          });
        } else if (this.partsOrderingType === 'TireConnect') {
          const warehouses = [];

          this.stores.forEach(({ delivery, supplier, store, parts }) => {
            warehouses.push({
              supplier: supplier?.id,
              delivery: delivery?.fields,
              tires: parts.map(({ itemId, quantity, orderingType }) => ({ tireId: itemId, quantity, branch: store.warehouseId, orderingType })),
            });
          });

          const shippingCosts = await this.httpService.getTCFreightCharges(warehouses);

          this.stores.forEach((store, index) => {
            store.shippingCost = shippingCosts[index]?.shipping_cost;
          });
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isShippingCostLoading = false;
    }
  }

  handleClose(isSuccess: boolean = false, data: any = {}) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }

  handleSubmit() {
    const shippings = {};

    this.stores.forEach(({ store, shippingCost }) => {
      shippings[store?.storeId] = shippingCost;
    });

    this.handleClose(true, shippings);
  }
}
